module.exports = __webpack_public_path__ + "media/images/landing_page/circular_truck_icon-d2397fbcc1dd2f81a6b2a70d088eb2d2.png";